export var getInitialValues = function getInitialValues(groups) {
  return groups.reduce(function (res, _ref) {
    var property = _ref.property,
        initial = _ref.initial;
    res[property] = initial;
    return res;
  }, {});
};